import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { useParams } from "react-router-dom";

import { queryKeyMap } from "@/features/query-client";

import { getLenderCompany } from "../api/company-api";

type ResponseType = Awaited<ReturnType<typeof getLenderCompany>>;

interface IOptions {
  enabled?: boolean;
  staleTime?: number;
}

export const useGetLenderCompanyQuery = (
  lenderCompanyId: number,
  options?: IOptions,
) => {
  return useQuery<ResponseType, AxiosError>({
    queryKey: queryKeyMap.getLenderCompany(lenderCompanyId),
    queryFn: async () => {
      return await getLenderCompany(lenderCompanyId);
    },
    ...options,
  });
};

export const useGetCurrentLenderCompanyQuery = () => {
  const { lenderCompanyId } = useParams();

  return useGetLenderCompanyQuery(Number(lenderCompanyId), {
    enabled: !!lenderCompanyId,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
